import React from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
//import PranzoCena from './PranzoCena';
import Caffè from './Caffè';
import Drink from './Drink';
import Consumer from './page/Consumer';
import Chef from './page/Chef';
import './App.css';
import MenuPdf from './MenuPdf';

function App() {
  return (
    <React.Fragment key={1}>
      <Router>
        <React.Fragment key={2}>
            <Route
                path="/menu_qr"
                render={({ location, history }) => {
                  // return(<PranzoCena/>
                  return(<MenuPdf/> 
                  )
                }}
            />
            <Route
                path="/caffe"
                render={({ location, history }) => {
                  return(<Caffè/>)
                }}
            />
            <Route
                path="/drink"
                render={({ location, history }) => {
                  return(<Drink/>)
                }}
            />
              <Route
                path="/chef"
                render={({ location, history }) => {
                  return(<Chef/>)
                }}
            />
            <Route
                path="/consumer"
                render={({ location, history }) => {
                  return(<Consumer/>)
                }}
            />
        </React.Fragment>
      </Router>
    </React.Fragment>
  );
}

export default App;
